import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('SURVEY').plugin(axiosPlugin);

let fetchSurveyAction = redux.fetchActionGetOne();

let createSurveyAction = redux.fetchActionCreate();

let updateSurveyAction = redux.fetchActionUpdate();

let deleteSurveyAction = redux.fetchActionDelete();

export const TYPES = redux.types;

export const fetchSurvey = (surveyId, query = {}) => fetchSurveyAction(`/forums//survey/${surveyId}?${queryString.stringify(query)}`);
export const createSurvey = (data = {}) => createSurveyAction(`/articles`, data);
export const updateSurvey = (surveyId, data = {}) => updateSurveyAction(`/articles/${surveyId}`, data);
export const deleteSurvey = (surveyId = {}) => deleteSurveyAction(`/articles/${surveyId}`);
export const resetSurvey = () => redux.actions.reset();

export const survey = redux.reducer();